"use client";

import storage from "@/lib/storage";
import { Loader } from "lucide-react";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    const checkAuth = () => {
      if (typeof window !== "undefined") {
        const token = storage.getItem("token");
        const isLoginPage = pathname === "/login";

        if (token) {
          // User has token
          setIsAuthenticated(true);
          if (isLoginPage) {
            router.push("/fleet-overview");
            return;
          }
        } else {
          setIsAuthenticated(false);
          if (!isLoginPage) {
            router.push("/login");
            return;
          }
        }

        setIsLoading(false);
      }
    };

    checkAuth();
  }, [router, pathname]);

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Loader className="animate-spin text-primary opacity-60" />
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
